module.exports = "/_next/static/images/BestStack-aba99bbfdb829c906d0052136532fca2.webp";